import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef} from 'react'

const STATUS = {
  STARTED: 'Started',
  STOPPED: 'Stopped',
}

const Timer = forwardRef((props, ref) => {

  const [secondsRemaining, setSecondsRemaining] = useState(120)
  const [status, setStatus] = useState(STATUS.STARTED)

  const secondsToDisplay = secondsRemaining % 60
  const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60
  const minutesToDisplay = minutesRemaining % 60
  const hoursToDisplay = (minutesRemaining - minutesToDisplay) / 60

//   const handleStart = () => {
//     setStatus(STATUS.STARTED)
//   }
//   const handleStop = () => {
//     setStatus(STATUS.STOPPED)
//   }
  function setRemainingTestTime(testTime){
	props.toCallParentSetRemainingTime(testTime);
  }
  function timeIsFinished(){
	props.toCallParentMethod();
  }

  useImperativeHandle(ref, () => ({
	resetTimer(opt){
		if(opt==1){
			setSecondsRemaining(props.endtime);
      setStatus(STATUS.STARTED);
		}else if(opt==2){
			setStatus(STATUS.STARTED);
		}else if(opt==3){
			setStatus(STATUS.STOPPED);
		}
	}
  }));

  useInterval(
    () => {
      if (secondsRemaining > 0) {
		    setRemainingTestTime(secondsRemaining);  
        setSecondsRemaining(secondsRemaining - 1);
      } else {
		timeIsFinished();  
        setStatus(STATUS.STOPPED)
      }
    },
    status === STATUS.STARTED ? 1000 : null,
    // passing null stops the interval
  )
  
  return (<>{twoDigits(hoursToDisplay)}:{twoDigits(minutesToDisplay)}:{twoDigits(secondsToDisplay)}</>)
});

export default Timer;

function useInterval(callback, delay) {
  const savedCallback = useRef()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

const twoDigits = (num) => String(num).padStart(2, '0')
